<template>
  <b-modal v-model="state.showModal"
           @ok="savePayment"
           ok-variant="info"
           :ok-disabled="state.isFetching">
    <div slot="modal-title">
      {{ $t('message.payment_method.add_payment') }}
    </div>
    <section>
      <payment-form ref="paymentForm" :paymentData="paymentData"/>
    </section>
    <div slot="modal-cancel" @click="state.showModal = false">{{ $t('message.button.close') }}</div>
    <div slot="modal-ok">{{ $t(isAdding) }}</div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PaymentForm from '../../payment/PaymentForm'
  import axios from 'axios'

  export default {
    props: {
      action: String
    },
    components: {
      PaymentForm
    },
    data () {
      return {
        paymentData: {
          name: null,
          number: null,
          expirationDate: '',
          securityCode: null,
          savePayment: true,
          displaySavePayment: false,
          isDefault: 0
        },
        omiseTokens: {
          secureToken: null,
          token: null
        }
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        isAdding: 'payment/isAdding',
        state: 'payment/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      'omiseTokens.token': function (newVal, oldVal) {
        if (this.omiseTokens.secureToken && this.omiseTokens.token) {
          let returnUri = location.href.split('?')[0] + '?tmpToken=' + this.omiseTokens.token
          const hasQueryParams = location.href.includes('?')
          if (hasQueryParams) {
            returnUri = this.getUriWithParams(location.href, { action: this.action, tmpToken: this.omiseTokens.token })
          } else {
            if (this.action) {
              returnUri = location.href + `?action=${this.action}&tmpToken=${this.omiseTokens.token}`
            }
          }
          const submitData = {
            user_id: this.user.id,
            token: this.omiseTokens.secureToken,
            return_uri: returnUri,
            omise_account: 'hellobeneat'
          }
          this.checkOmiseSecure(submitData)
        }
      }
    },
    methods: {
      getUriWithParams (baseUrl, params) {
        const Url = new URL(baseUrl)
        const urlParams = new URLSearchParams(Url.search)
        for (const key in params) {
          if (params[key] !== undefined) {
            urlParams.set(key, params[key])
          }
        }
        Url.search = urlParams.toString()
        return Url.toString()
      },
      showPaymentModal (status) {
        this.$store.commit('payment/SET_MODAL_DISPLAY', status)
      },
      checkOmiseSecure (submitData) {
        const url = 'payments/' + this.user.id + '/check-omise-secure'
        axios.post(url, submitData)
          .then(res => {
            this.$store.commit('payment/FINISH_REQUEST_DATA')
            const response = res.data
            if (!response.error) {
              this.showPaymentModal(false)
              this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', response.omise_charge_id)
              window.location = response.authorize_uri
            } else {
              this.$swal({text: response.message, type: 'error'})
              this.omiseTokens.secureToken = null
              this.omiseTokens.token = null
            }
          })
          .catch(error => {
            this.showPaymentModal(false)
            console.log(error)
          })
      },
      savePayment (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        if (this.$refs.paymentForm.paymentFormValidation()) {
          this.omiseTokens.secureToken = null
          this.omiseTokens.token = null
          this.$store.commit('payment/REQUEST_PAYMENT_DATA')
          // Prepare card data
          const cardNumber = this.paymentData.number.replace(/\s+/g, '')
          let arrExpiration = this.paymentData.expirationDate.split('/')
          const expirationMonth = arrExpiration[0]
          const expirationYear = 2000 + parseInt(arrExpiration[1])

          const card = {
            'name': this.paymentData.name,
            'number': cardNumber,
            'expiration_month': expirationMonth,
            'expiration_year': expirationYear,
            'security_code': this.paymentData.securityCode
          }

          this.omiseTokens.secureToken = null
          this.omiseTokens.token = null
          // Get token from omise secure for otp
          window.Omise.setPublicKey(this.globalState.omisePublicKey)
          window.Omise.createToken('card', card, (statusCode, response) => {
            if (statusCode === 200 && response.object === 'token') {
              const omiseToken = response.id
              this.omiseTokens.secureToken = omiseToken
              // Get token from omise non-secure for adding omise customer id
              window.Omise.setPublicKey(this.globalState.omisePublicKey)
              window.Omise.createToken('card', card, (statusCode, response) => {
                if (statusCode === 200 && response.object === 'token') {
                  const omiseToken = response.id
                  this.omiseTokens.token = omiseToken
                  this.$store.commit('payment/SET_TMP_OMISE_TOKEN', omiseToken)
                  this.$store.commit('payment/SET_TMP_IS_DEFAULT_CARD', this.paymentData.isDefault)
                } else {
                  const alertText = 'Error: ' + response.message
                  this.$swal({text: alertText})
                  this.$store.commit('payment/FINISH_REQUEST_DATA')
                }
              })
            } else {
              const alertText = 'Error: ' + response.message
              this.$swal({text: alertText})
              this.$store.commit('payment/FINISH_REQUEST_DATA')
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/payment/UserPaymentForm.vue